import React, { Component } from "react";
import { Form, BackTop, Modal, Card, Button } from "antd";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import GeneralDetails from "./Components/GeneralDetails";
import TaxationDetails from "./Components/TaxationDetails";
import AN22TaxationDetails from "./Components/AN22TaxationDetails";
import ContactPersonDetails from "./Components/ContactPersonDetails";
import CompanyDetails from "./Components/CompanyDetails";
import AdditionalDetails from "./Components/AdditionalDetails";
import PaymentDetails from "./Components/PaymentDetails";
import FMEDetails from "./Components/FMEDetails";
import RegistrationDataProvider from "./RegistrationDataProvider";
import {
  DEPENDENT_DROPDOWN_FIELDS,
  DROPDOWN_FIELDS,
  FIELD_ALIAS,
  MULTIVALUE_FIELDS,
  STATUS_WISE_RESET_FIELDS,
  CONVERT_TO_TYPE,
  NOTIFICATIONS,
  FILE_UPLOAD_FIELDS,
  SUBMIT_VALUES,
  URLS,
  SCROLL_TO_FIELD_FOR_FILE,
  SCROLL_TO_FIELD_SERIA,
  SCREEN_ROUTES,
  TCSRadio,
  STATIC_STRINGS,
  INDIA,
  Actions,
  director_fields,
  India,
  UNITED_STATES,
  SCROLL_TO_FIELD_FOR_MULTIV,
  TO_DECIMAL,
  DIRECTOR_FIELDS,
  CONTACT_PERSON_FIELDS,
  DECLARATION_LETTER_TOOLTIP,
  REFRESH_NOTIFICATION,
  encrypt_fields,
  randomString,
  COOKIE_EXPIRY_DATE,
  SHIPPING_BILLING_URL,
  SHIPPING_BILLING_MSG,
  QUERY,
  CONTACT_PERSON_VALIDATION_FIELDS,
  STATUS_RADIO,
  AVOID_IN_TRIM,
  RETAIN_VALUES,
  CONTACT_PERSON_MULTIVALUE_FIELDS,
  REQ_INDUSTRIES,
  SOURCE_KHOPOLI,
} from "../../../constants";
import {
  downloadFileFromServer,
  downloadFileLocal,
} from "./RegistrationFormViewHelper";
import CustomLoader from "./Components/CustomLoader";
import CustomHeader from "./Components/CustomHeader";
import CustomFooter from "./Components/CustomFooter";
import DirectorDetails from "./Components/DirectorDetails";

import {
  director_details_validator,
  invalidCharacterValidator,
  contact_person_validator,
  mailRegex,
  phoneNumberRegex,
  telephoneRegex,
  UdyamValidator,
} from "./validators";
import {
  Dynamic_Error,
  Internal_Server_Error,
} from "../../RegisterAN13/RegisterAN13FormView/AN13FormHelper";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { ErrorLogger } from "../../../../App/Utils/ErrorHandler";
import BankDetails from "./Components/BankDetails";
import RegistrationTimer from "../../../../Auth/screens/ResetPassword/RegistrationTimer";

const { confirm } = Modal;

class RegistrationFormView extends Component {
  formRef =
    this.props.formRef === undefined ? React.createRef() : this.props.formRef;

  otpFormRef = React.createRef();
  path = this.props.history.location.pathname;
  route = !this.path.includes(URLS.REGISTRATION)
    ? this.path.split("/").pop()
    : undefined;
  isDisabled = window.location.pathname.includes(
    SCREEN_ROUTES.VIEW_REGISTRATION_FORM
  );
  source = new URLSearchParams(this.props.history.location.search).get(
    QUERY.source
  );
  reference = new URLSearchParams(this.props.history.location.search).get(
    QUERY.reference
  );
  prospectId = new URLSearchParams(this.props.history.location.search).get(
    QUERY.prospectId
  );
  // BELOW ID IS USED TO MAINTAIN ID WHEN DIREC DETAIL RECO IS REMOVED
  updatedId = null;
  record = null;
  contact_person_grid_data = {};

  DataProvider = new RegistrationDataProvider();

  state = {
    isLoading: false,
    disable_fme: false,
    message: NOTIFICATIONS.PLEASE_WAIT,
    versionList: [],
    customerData: {},
    updateGrid: true,
    crmUserData: {},
    //BELOW ARE FOR FILE UPLOADS
    uploadedFiles: {},
    fileConfigs: {},
    //BELOW ARE FOR MAINTAINING DISABLED FIELDS
    gst_registration_status: false,
    cin_number_status: false,
    tan_number_status: false,
    //BELOW ARE FOR SECTIONS SHOW/HIDE
    agreeINS: false,
    agreeTC: false,
    showSave: true,
    director_details_status: false,
    //BELOW ARE FOR SECTION VISIBILITY
    taxationVisible: false,
    cinRequiredIndustry:false,
    isCinEnabled: false,
    //BELOW ARE FOR ADDITIONAL DETAILS ONLY WHEN EDIT FORM
    additional_details: {
      customer_email: [],
      director_details: [],
      sister_company_details: [],
      contact_person_details: [],
      director_details: [],
    },
    //BELOW ARE FOR DROPDOWNS
    country: null,
    customer_sap_code: null,
    fmeData: [],
    countryData: [],
    statesData: [],
    citiesData: [],
    otherCity: [],
    othertype: {},
    tcsStatus: [],
    gstCodeData: [],
    currency: [],
    // TOOLTIP BASED ON TCSStatus SELECTION
    dec_letter_tooltip: "",
    //BELOW ARE FOR DROPDOWN BASED CONDITIONS
    pincodeLength: 0,
    //BELOW ARE FOR EDIT DATA
    editDataAvailable: false,
    isInEdit: this.route !== undefined ? true : false,
    isStaff: localStorage.getItem("is_staff") === "true" ? true : false,
    is_verified_in_mdm: false,
    //BELOW ARE FOR MAINTAINING OPTIONAL FIELDS
    registrationFields: {},
    optional_fields: {},
    isOptional: window.location.pathname.includes("RegisterFME") ? true : false,
    isAN13Update: false,
    isAN22: false,
    isRequired: true,
    aadharRequired: false,
    req_op_fields: { O: {}, S: {} },
    receiveRegistrationMail: false,
    industriesData: [],
    is_tan_required: false,
    is_gst_required: false,
    is_udyam_required: true,
    is_udyam_visible: false,
    is_reverted_in_mdm: false,
    is_reverted_to_customer: false,
    codereq_pk: null,
    // BELOW ARE FOR MULTIVALUE FIELDS e.g contact_person_email, company_email etc
    multivalue_fields: {
      contact_person_email: [],
      contact_person_mobile_number: [],
      contact_person_telephone_number: [],
    },
    multivalue_fields_original: {
      contact_person_email: [],
      contact_person_mobile_number: [],
      contact_person_telephone_number: [],
    },
    showOTPModal: false,
    registrationOtpPayload: {},
    pendingRegistrationData: null
  };

  componentDidMount() {
    // GET DATA BY PROSPECT ID IF FOUND IN URL
    // if (this.prospectId) {
    //  this.getDataByProspectId(this.prospectId);
    //}
    localStorage.removeItem("registration-otp-duration");

    const project_route =
      process.env.REACT_APP_PROJECT_ROUTE != "/null"
        ? process.env.REACT_APP_PROJECT_ROUTE
        : "";

    var r = `/^${project_route}$/`;
    if (
      (window.location.pathname.includes(project_route + "/RegisterFME") ||
        window.location.pathname.includes(project_route + "/Register") ||
        window.location.pathname.includes(project_route + "/Registration") ||
        window.location.pathname.includes(
          project_route + "/UpdateRegistrationForm/"
        )) &&
      !r.match(window.location.pathname)
    ) {
      window.onbeforeunload = function () {
        return "";
      };
    }

    try {
      this.getCountries();
      this.getFileConfig();
      this.getRadioValues();
      this.getTypeOfIndustry();
      if (this.state.isInEdit === false && this.state.isStaff === false) {
        this.setState({ agreeINS: false });
      } else if (this.state.isInEdit && this.state.isStaff === false) {
        this.getUserData();
        // this.getVersionHistory();
      } else {
        this.setState({ agreeINS: true });
      }

      if (
        window.location.pathname.includes(project_route + "/RegisterFME") ||
        window.location.pathname.includes(project_route + "/Register") ||
        window.location.pathname.includes(
          project_route + "/UpdateRegistrationForm/"
        )
      ) {
        openNotification(
          openNotificationType.info,
          REFRESH_NOTIFICATION.message,
          REFRESH_NOTIFICATION.description
        );
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  }

  // TO DISABLE FIELDS WHEN CUSTOMER CODE REQ IS IN PROGRESS
  getReqOpFields = () => {
    try {
      this.DataProvider.get_req_op_fields_api().then((res) => {
        if (res.ok) {
          return res.json().then((res) => {
            this.setState({ req_op_fields: res });
          });
        } else {
          return res.json().then((res) => {
            Object.keys(res).forEach((k) => {
              Dynamic_Error(k, res[k]);
            });
          });
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  getRadioValues = () => {
    try {
      this.DataProvider.get_dropdown_data_api(
        TCSRadio.app,
        TCSRadio.model
      ).then((res) => {
        if (res.ok) {
          return res.json().then((res) => {
            for (var each in res) {
              res[each][STATIC_STRINGS.TOOLTIP] =
                res[each][STATIC_STRINGS.NAME].split("||")[1];
              res[each][STATIC_STRINGS.NAME] =
                res[each][STATIC_STRINGS.NAME].split("||")[0];
              res[each][STATIC_STRINGS.VALUES] = res[each][STATIC_STRINGS.ID];
              res[each][STATIC_STRINGS.ID] =
                res[each][STATIC_STRINGS.ID].toString();
              if (res[each][STATIC_STRINGS.ID] == "3") {
                res[each][STATIC_STRINGS.DISABLED] = true;
              } else {
                res[each][STATIC_STRINGS.DISABLED] = false;
              }
            }
            if (
              !window.location.pathname.includes(
                SCREEN_ROUTES.UPDATE_REGISTRATION_FORM
              )
            ) {
              res = res.filter((item) => item.id !== "3");
            }
            this.setState({ tcsStatus: res });
          });
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  getUserData = () => {
    try {
      this.setState({ isLoading: true, agreeINS: true });
      this.DataProvider.get_user_data_api(this.route)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              this.getRegistrationFields(res.id);
              this.getAllFmes(res.employee_name);
              this.getFileConfig();
              this.get_currency(res.country_name);

              // DISABLED FIELDS IF CODE REQ IS APPROVED
              if (res.is_verified_in_mdm && res.disable_fields) {
                this.getReqOpFields();
              }

              //TO DECODE base64 TO ASCII
              encrypt_fields.forEach((each) => {
                if (
                  each in res &&
                  res[each] !== null &&
                  res[each] !== undefined &&
                  res[each] !== ""
                ) {
                  res[each] = window.atob(res[each]);
                }
              });

              //TO SET MULTIPLE VALUE FIELDS
              let additional_details = {};
              Object.keys(MULTIVALUE_FIELDS).forEach((decorator) => {
                additional_details[decorator] =
                  res[decorator] !== undefined && res[decorator].length > 0
                    ? res[decorator]
                    : decorator !== MULTIVALUE_FIELDS.director_details &&
                      decorator !== MULTIVALUE_FIELDS.contact_person_details
                    ? [{ id: 0, value: "" }]
                    : [];
              });

              if (res.tcs_applicable_status !== 3) {
                let tcsStatus = this.state.tcsStatus.filter(
                  (item) => item.id !== "3"
                );
                this.setState({ tcsStatus });
              }

              this.setState({
                additional_details,
                editDataAvailable: true,
                showSave: res.show_save,
                disable_fme: true,
                director_details_status: res.director_details_status,
                customerData: res,
                customer_sap_code: res.customer_sap_code,
                tcs_applicable_status: res.tcs_applicable_status,
                is_verified_in_mdm: res.is_verified_in_mdm,
                is_reverted_in_mdm: res.is_reverted_in_mdm,
                is_reverted_to_customer: res.is_reverted_to_customer,
                codereq_pk: res.codereq_pk
              });

              //TO MANAGE ALIAS FIELDS
              Object.keys(FIELD_ALIAS).map((key) => {
                res[FIELD_ALIAS[key].decorator] = res[FIELD_ALIAS[key].field];
                delete res[FIELD_ALIAS[key].field];
              });

              //CONVERT DATA TO PARTICULAR DATA TYPE
              CONVERT_TO_TYPE.map((t) => {
                res[t.decorator] = t.type(res[t.decorator]);
              });

              //TO SET FILES
              let uploadedFiles = {};
              try {
                Object.keys(FILE_UPLOAD_FIELDS).map((decorator) => {
                  let fileList = res.files.filter(
                    (f) => f.category === decorator
                  );
                  uploadedFiles = { ...uploadedFiles, [decorator]: fileList };
                  this.formRef.current.setFieldsValue({
                    [decorator]: fileList,
                  });
                });
              } catch (error) {}

              //TO ENABLE/DISABLE TAXATION SECTION BASED ON COUNTRY
              const isCountryInd =
                res.country_name.toString().toLowerCase() === INDIA;
              const isOtherCity =
                res.other_city !== "" &&
                res.other_city !== null &&
                res.other_city
                  ? [{ city_id: 0, name: res.other_city, other: true }]
                  : [];
              const is_gst_required =
                isCountryInd &&
                (res.source_name === QUERY.ecommerce ||
                  res.source_name === QUERY.msme || res.source_name === QUERY.cfs)
                  ? true
                  : false;

              // TO SHOW UDYAM SECTION
              const is_udyam_visible =
                isCountryInd && res.source_name === QUERY.msme ? true : false;

              // TO MAKE REQUIRED UDYAM NUMBER AND ATTACHMENT
              const is_udyam_required = true;

               // To enable cin number in case of cin required type of industry
              const isCinEnabled = REQ_INDUSTRIES.find(item=>res.type_of_industry_name.toLowerCase().includes(item)) === undefined?false
              :(!res.cin_number)?true:false
              const cinRequiredIndustry = REQ_INDUSTRIES.find(item=>res.type_of_industry_name.toLowerCase().includes(item)) === undefined?false:true
              this.setState(
                {
                  otherCity: isOtherCity,
                  taxationVisible: isCountryInd,
                  pincodeLength: isCountryInd ? 6 : 10,
                  uploadedFiles,
                  isOptional: window.location.pathname.includes("RegisterFME")
                    ? true
                    : isCountryInd
                    ? false
                    : true,
                  is_gst_required: is_gst_required,
                  is_udyam_visible: is_udyam_visible,
                  is_udyam_required: is_udyam_required,
                  cin_number_status:isCinEnabled,
                  isCinEnabled:isCinEnabled,
                  cinRequiredIndustry:cinRequiredIndustry
                },
                () => {
                  if (this.state.taxationVisible) {
                    //TOGGED HTML CONTROL ENABLE/DISABLE BASED ON DATA RECEIVED
                    Object.keys(STATUS_WISE_RESET_FIELDS).map((decorator) => {
                      if (res[decorator] === true) {
                        this.setState({ [decorator]: true });
                      }
                    });
                  }
                }
              );

              // To Fetch Currency dropdown values
              if (isCountryInd === true) {
                this.get_currency(India);
              } else {
                this.get_currency(UNITED_STATES);
              }

              //TO LOAD DEPENDENT DATA
              this.get_dropdown_dependent_data(
                DEPENDENT_DROPDOWN_FIELDS.state.app,
                DEPENDENT_DROPDOWN_FIELDS.state.model,
                DEPENDENT_DROPDOWN_FIELDS.state.dependent,
                res.country,
                DEPENDENT_DROPDOWN_FIELDS.state.storein
              );

              // null WHEN STATE IS NOT SELECTED DUE TO OPTIONAL
              if (res.state !== null) {
                this.get_dropdown_dependent_data(
                  DEPENDENT_DROPDOWN_FIELDS.city.app,
                  DEPENDENT_DROPDOWN_FIELDS.city.model,
                  DEPENDENT_DROPDOWN_FIELDS.city.dependent,
                  res.state,
                  DEPENDENT_DROPDOWN_FIELDS.city.storein
                );

                //TO LOAD RELATED GST CODE
                this.get_dropdown_dependent_data(
                  DEPENDENT_DROPDOWN_FIELDS.gstcode.app,
                  DEPENDENT_DROPDOWN_FIELDS.gstcode.model,
                  DEPENDENT_DROPDOWN_FIELDS.gstcode.dependent,
                  res.state,
                  DEPENDENT_DROPDOWN_FIELDS.gstcode.storein
                );
              } else {
                this.get_dropdown_dependent_data(
                  DEPENDENT_DROPDOWN_FIELDS.city.app,
                  DEPENDENT_DROPDOWN_FIELDS.city.model,
                  DEPENDENT_DROPDOWN_FIELDS.city.country_dependent,
                  res.country,
                  DEPENDENT_DROPDOWN_FIELDS.city.storein
                );
              }
              //TO SET FIELDS VALUE
              try {
                Object.keys(res).map((decorator) => {
                  this.formRef.current.setFieldsValue({
                    [decorator]: res[decorator],
                  });
                });

                if (this.state.is_gst_required) {
                  // GST REQUIRED IN CASE OF ECOM CUSTOMER
                  this.formRef.current.setFieldsValue({
                    gst_registration_status: true,
                  });
                }
                //To set cin registered true based on industry type
                if (isCinEnabled&&!this.path.includes("ChangeRequest")) {
                  this.formRef.current &&
                    this.formRef.current.setFieldsValue({
                      cin_number_status: true,
                    });
                }
              } catch (error) {
                console.error(error);
              }
            });
          } else if (res.status === 403) {
            return res.json().then((res) => {
              Object.keys(res).map((k) => {
                openNotification(openNotificationType.error, k, res[k]);
              });
              this.props.history.push(URLS.BASEROUTE);
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((k) => {
                openNotification(openNotificationType.error, k, res[k]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  getTypeOfIndustry = () => {
    try {
      this.DataProvider.get_type_of_industry_api("CRP").then((res) => {
        if (res.ok) {
          return res
            .json()
            .then((res) => this.setState({ industriesData: res }));
        } else {
          openNotification(
            openNotificationType.error,
            notificationTitle.api,
            NOTIFICATIONS.GET_INDUSTRIES_ERROR
          );
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  onFinish = (values) => {
    try {
      // ENSURE USER HAS CHECKED TERM AND CONDITIONS IN REGULAR FORM
      // AVOID IN CASE OF PSU AND AN13
      if (!this.state.isInEdit && !this.state.isStaff && !this.state.agreeTC) {
        openNotification(
          openNotificationType.error,
          notificationTitle.form,
          NOTIFICATIONS.AGREE_TANDC
        );
        return;
      }

      let isValid = true;
      let { contact_person_details } = this.state.additional_details;
      // To Check If Contact Person Details is Empty
      if (contact_person_details.length === 0) {
        openNotification(
          openNotificationType.error,
          notificationTitle.form,
          NOTIFICATIONS.CONTACT_PERSON_DETAILS
        );
        isValid = false;
        return;
      } else if (contact_person_details.length > 0) {
        // CHECK THAT ATLEAST ONE CONTACT SHOULD BE PRIMARY
        let has_primary = false;
        contact_person_details.forEach((each_row) => {
          if (each_row.contact_person_status === "Primary") {
            has_primary = true;
          }
        });

        if(!has_primary){
          openNotification(
            openNotificationType.error,
            notificationTitle.form,
            NOTIFICATIONS.ATLEAST_ONE_PRIMARY
          );
          isValid = false;
          return {};
        }

        // VALIDATE EACH ROW
        contact_person_details.forEach((each_row) => {
          if (!contact_person_validator(each_row, this.formRef, false)) {
            isValid = false;
            return;
          }
        });

        if (!isValid) {
          openNotification(
            openNotificationType.error,
            notificationTitle.form,
            NOTIFICATIONS.CORRECT_CONTACT_DETAILS
          );
          return;
        }
      }

      // VALIDATE Udyam NUMBER
      if (
        values.udyam_number !== undefined &&
        values.udyam_number !== null &&
        values.udyam_number !== ""
      ) {
        if (!UdyamValidator(null, values.udyam_number)) {
          return;
        }
      }

      // To Check If Director Details is Empty
      if (
        this.state.director_details_status == true &&
        this.state.additional_details.director_details.length === 0
      ) {
        openNotification(
          openNotificationType.error,
          notificationTitle.form,
          NOTIFICATIONS.DIRECTOR_DETAILS
        );
      } else {
        //GST NUMBER SHOULD CONTAIN PAN NUMBER
        let isValid = true;
        if (
          values.gst_number !== undefined &&
          values.gst_number !== null &&
          values.gst_number !== ""
        ) {
          if (
            !values.gst_number
              .toLowerCase()
              .includes(values.pan_number.toLowerCase())
          ) {
            isValid = false;
          } else if (
            !values.gst_number
              .slice(0, 2)
              .toString()
              .includes(this.state.gstCodeData[0].name)
          ) {
            isValid = false;
          }

          if (!isValid) {
            // ENABLE GST NUMBER IF FOUND ERROR
            let { req_op_fields } = this.state;
            delete req_op_fields.S[SCROLL_TO_FIELD_FOR_FILE.gst_document[0]];
            this.setState({ req_op_fields });

            this.formRef.current.scrollToField(
              SCROLL_TO_FIELD_FOR_FILE.gst_document[0]
            );

            this.formRef.current.setFields([
              {
                name: SCROLL_TO_FIELD_FOR_FILE.gst_document[0],
                errors: NOTIFICATIONS.VALIDATE_GST,
              },
            ]);

            return;
          }
        }

        Object.keys(MULTIVALUE_FIELDS).map((each_field) => {
          let new_list = [];
          if (values[each_field] !== undefined) {
            values[each_field].map((each_record) => {
              if (each_record !== undefined) {
                if (each_record.value !== "")
                  new_list = [...new_list, each_record.value];
              }
            });
            values[each_field] = new_list;
          }
        });

        // VALIDATE MOBILE AND TELEPHONE ONLY FOR INDIAN
        let isValidMob = true;
        // let isValidTel = true;
        let isValidEmail = true;
        if (this.state.taxationVisible) {
          // MOBILE
          isValidMob = this.validateMobTeleEmail(
            values.company_contactno,
            telephoneRegex,
            NOTIFICATIONS.MOB_INVALID
          );
        }

        //VALIDATE EMAIL ADDRESS
        isValidEmail = this.validateMobTeleEmail(
          values.company_email,
          mailRegex,
          NOTIFICATIONS.EMAIL_INVALID
        );

        // return IF MOBILE OR TELEPHONE NUM OR EMAIL IS INVALID IS INVALID
        if (!isValidMob || !isValidEmail) {
          return;
        }

        // REMOVE NULL VALUES OF DIRECTOR DETAIL FIELDS AND UPDATE WITH STATE DATA
        director_fields.map((each_field) => {
          delete values[each_field];
        });
        values.director_details =
          this.state.additional_details.director_details;
        // REMOVE NULL VALUES OF CONTACT PERSON DETAILS FIELDS AND UPDATE WITH STATE DATA
        CONTACT_PERSON_FIELDS.map((each_field) => {
          delete values[each_field];
        });
        values.contact_person_details =
          this.state.additional_details.contact_person_details;

        //TO MANAGE SELETED OTHERTYPE FROM CMB
        let { othertype, otherCity } = this.state;
        Object.keys(othertype).map((key) => {
          delete values[key];
          values[`${SUBMIT_VALUES.OTHER}_${key}`] = othertype[key].name;
        });

        if (values.city === 0) {
          delete values.city;
          values[`${SUBMIT_VALUES.OTHER}_${DROPDOWN_FIELDS.city}`] =
            otherCity[0].name;
        }

        //TO MANAGE ALIAS FIELDS
        Object.keys(FIELD_ALIAS).map((key) => {
          values[FIELD_ALIAS[key].field] = values[FIELD_ALIAS[key].decorator];
          delete values[FIELD_ALIAS[key].decorator];
        });

        // TO MANAGE FLOAT VALUES FOR BACKEND
        TO_DECIMAL.forEach(
          (row) =>
            (values[row.decorator] = parseFloat(values[row.decorator]).toFixed(
              row.decimal
            ))
        );

        // TO ENCRYPT pan_number, gst_number FIELDS
        encrypt_fields.forEach((each) => {
          if (
            each in values &&
            values[each] !== null &&
            values[each] !== undefined &&
            values[each] !== ""
          ) {
            values[each] = window.btoa(values[each]);
          }
        });

        // DO NOT PROCEED IF HAVING SPECIAL CHARACTERS
        if (invalidCharacterValidator(values, this.formRef) === false) return;

        let formData = new FormData();

        //TO MANAGE MULTIPLE UPLOADED FILES
        let oldFiles = [];
        var { uploadedFiles } = this.state;
        Object.values(FILE_UPLOAD_FIELDS).forEach((v) => {
          if (uploadedFiles[v] != null) {
            uploadedFiles[v].forEach((file, index) => {
              if (file && file.status) {
                file.attachment_type = v;
                oldFiles.push(file);
              } else {
                formData.append(`${v}${index}`, file);
              }
            });
          } else {
            formData.append(v, null);
          }
          delete values[v];
        });

        // TO IDENTIFY TYPE OF REGISTRATION e.g E-Commerce, CRM.
        // DO NOT CONSIDER PARAMS IN ANY OTHER CASE LIKE AN13, Update data
        let source = this.source;

        if(this.path.includes(SOURCE_KHOPOLI)){
          source = SOURCE_KHOPOLI;
          values.source = source.trim();
        }

        if (
          source &&
          source !== "" &&
          this.state.isInEdit === false &&
          this.state.isStaff === false
        ) {
          values.source = source.trim();
        }

        // TO KEEP TRACK WHICH CUST HAS SELECTED NO FOR is_shipping_billing_same RADIO
        // AND REGISTERED AGAIN FROM REGISTER SUCCESS PAGE
        const reference = this.reference;
        if (
          reference &&
          reference !== "" &&
          this.state.isInEdit === false &&
          this.state.isStaff === false
        ) {
          values.customer_reference = reference.trim();
          values.is_billing_shipping_same = true;
        }

        formData.append(SUBMIT_VALUES.OLD_FILES, JSON.stringify(oldFiles));
        formData.append(SUBMIT_VALUES.DATA, JSON.stringify(values));
        this.setState({pendingRegistrationData: formData});

        if (this.state.isInEdit === false && this.state.isStaff === false) {
          this.triggerRegistrationOTP(values);
        } else if (this.state.isInEdit && this.state.isStaff === false) {
          // USED FOR BOTH NORMAL UPDATE AND INIT CHANGE REQUEST
          this.updateCustomer(formData);
        } else {
          this.triggerRegistrationOTP(values);
        }
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  onFinishFailed = (values) => {
    this.formRef.current.scrollToField(values.errorFields[0].name);

    Object.keys(SCROLL_TO_FIELD_FOR_FILE).map((decorator) => {
      if (decorator === values.errorFields[0].name[0]) {
        this.formRef.current.scrollToField(SCROLL_TO_FIELD_FOR_FILE[decorator]);
      }
    });

    //SHOW ERROR NOTIFICATION
    try {
      if (values.errorFields.length > 3) {
        openNotification(
          openNotificationType.error,
          notificationTitle.form,
          NOTIFICATIONS.FORM_VALIDATION
        );
      } else {
        values.errorFields.map((each) => {
          openNotification(
            openNotificationType.error,
            notificationTitle.form,
            each.errors[0] === " " ? NOTIFICATIONS.REQUIRED : each.errors[0]
          );
        });
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  // MODAL POPUP ON SUBMIT. FOR PSU REGISTRATION TO DECIDE WHETHER TO RECEIVE MAILS OR NOT
  receiveMails = (values) => {
    const context = this;
    confirm({
      title: "Receive Mails",
      icon: <ExclamationCircleOutlined />,
      content: "Do you want to receive registration mails?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        values[SUBMIT_VALUES.RECEIVE_MAILS] = true;
        context.onFinish(values);
      },

      onCancel() {
        values[SUBMIT_VALUES.RECEIVE_MAILS] = false;
        context.onFinish(values);
      },
    });
  };

  get_dropdown_dependent_data = (app, model, dependent, id, state) => {
    try {
      this.DataProvider.get_dependent_dropdown_data_api(
        app,
        model,
        dependent,
        id,
        state
      ).then((res) => {
        if (res.ok) {
          return res.json().then((res) => this.setState({ [state]: res }));
        } else {
          openNotification(
            openNotificationType.error,
            NOTIFICATIONS.ERROR_OCCURED,
            NOTIFICATIONS.REFRESH_PAGE
          );
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  registerCustomer = (formData, unique_cust_id) => {
    try {
      this.setState(
        { isLoading: true, message: NOTIFICATIONS.SAVING_DATA },
        () =>
          setTimeout(() => {
            this.setState({ message: NOTIFICATIONS.UPLOADING_FILES });
          }, 2000)
      );
      formData.append('unique_cust_id', unique_cust_id);

      this.DataProvider.registration_customer_api(formData)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              if (
                this.state.isInEdit === false &&
                this.state.isStaff === false
              ) {
                window.onbeforeunload = null;

                // KEEP USING UUID OF FIRST REGISTRATION
                const reference = res.customer_reference
                  ? res.customer_reference
                  : res.customer_pk;

                // WHEN USER REGISTER AGAIN WITH REFERENCE UUID
                if (res.is_billing_shipping_same && res.customer_reference) {
                  this.props.history.push(URLS.REGISTER_SUCCESS, {
                    shipping_billing_msg: SHIPPING_BILLING_MSG[1],
                    shipping_billing_url: SHIPPING_BILLING_URL(
                      reference,
                      this.source
                    ),
                  });
                }
                // WHEN USER SELECTED True VALUE FOR is_billing_shipping_same
                else if (res.is_billing_shipping_same) {
                  this.props.history.push(URLS.REGISTER_SUCCESS);
                } else {
                  // WHEN USER SELECTS False VALUE FOR is_billing_shipping_same
                  this.props.history.push(URLS.REGISTER_SUCCESS, {
                    shipping_billing_msg: SHIPPING_BILLING_MSG[0],
                    shipping_billing_url: SHIPPING_BILLING_URL(
                      reference,
                      this.source
                    ),
                  });
                }
              } else {
                openNotification(
                  openNotificationType.success,
                  notificationTitle.form,
                  NOTIFICATIONS.SUCCESS_REGISTER
                );
                setTimeout(() => {
                  window.onbeforeunload = null;
                  window.location.reload();
                }, 500);
              }
            });
          } else {
            return res.json().then((res) => {
              let errorFieldName = Object.keys(res)[0];
              this.formRef.current.scrollToField(errorFieldName);

              Object.keys(res).map((k) => {
                let title = k.replace("_", " ").replace("_", " ");
                title = title.charAt(0).toUpperCase() + title.slice(1);

                openNotification(openNotificationType.error, title, res[k]);

                // FOR FIELDS WHICH ARE DIFFRENT FROM BACK AND FRONT
                if (SCROLL_TO_FIELD_SERIA[k] !== undefined) {
                  k = SCROLL_TO_FIELD_SERIA[k];
                }
                this.formRef.current.setFields([
                  {
                    name: k,
                    errors: res[k],
                  },
                ]);
              });
            });
          }
        })
        .finally(() =>
          this.setState({
            isLoading: false,
            message: NOTIFICATIONS.PLEASE_WAIT,
          })
        );
    } catch (error) {
      this.setState({ isLoading: false, message: NOTIFICATIONS.PLEASE_WAIT });
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  updateCustomer = (formData) => {
    try {
      this.setState({ isLoading: true });

      // IF VERIFIED THEN INIT CHANGE REQ AND IF NOT THEN NORMAL UPDATE
      let api = this.state.is_verified_in_mdm
        ? this.DataProvider.init_change_request_api
        : this.DataProvider.update_customer_api;

      if(this.state.is_reverted_to_customer){
        api = this.DataProvider.update_reverted_customer
        formData.append("customer_pk", this.route)
        formData.append("codereq_pk", this.state.codereq_pk)
        formData.append("remarks", "Updated")
      }

      api(this.route, formData)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              openNotification(
                openNotificationType.success,
                notificationTitle.form,
                NOTIFICATIONS.FORM_UPDATED_SUCCESS
              );

              setTimeout(() => {
                window.onbeforeunload = null;
                window.location.reload();
              }, 1000);
            });
          } else {
            return res.json().then((res) => {
              let errorFieldName = Object.keys(res)[0];
              this.formRef.current.scrollToField(errorFieldName);

              Object.keys(res).map((k) => {
                let title = k.replace("_", " ").replace("_", " ");
                title = title.charAt(0).toUpperCase() + title.slice(1);

                openNotification(openNotificationType.error, title, res[k]);

                // FOR FIELDS WHICH ARE DIFFRENT FROM BACK AND FRONT
                if (SCROLL_TO_FIELD_SERIA[k] !== undefined) {
                  k = SCROLL_TO_FIELD_SERIA[k];
                }
                this.formRef.current.setFields([
                  {
                    name: k,
                    errors: res[k],
                  },
                ]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      this.setState({ isLoading: false });
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  onBackPressed = () => {
    this.props.history.goBack();
  };

  removeFile = (file, decorator) => {
    try {
      var { uploadedFiles } = this.state;
      if (uploadedFiles.hasOwnProperty(decorator)) {
        uploadedFiles[decorator] = uploadedFiles[decorator].filter(
          (f) => f && f.uid !== file.uid
        );
        this.setState({ uploadedFiles: uploadedFiles });
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Exception raised for ${decorator} with value ${file}`);
      console.error(error);
    }
  };

  addFile = (file, decorator) => {
    try {
      let { uploadedFiles } = this.state;
      this.setState(
        {
          uploadedFiles: {
            ...uploadedFiles,
            [decorator]:
              uploadedFiles[decorator] !== undefined
                ? [...uploadedFiles[decorator], file]
                : [file],
          },
        },
        () =>
          this.formRef.current.setFieldsValue({
            [decorator]: this.state.uploadedFiles[decorator],
          })
      );
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Exception raised for ${decorator} with value ${file}`);
      console.error(error);
    }
  };

  goToLogin = () => {
    this.props.history.push("Login");
  };

  getRegistrationFields = (id) => {
    try {
      this.DataProvider.get_customer_fields_api(id).then((res) => {
        if (res.ok) {
          return res.json().then((res) => {
            if (Object.keys(res).length === 0) {
              return;
            } else {
              this.setState({
                isAN13Update: res.account_group_code === "AN13" ? true : false,
                isAN22: res.account_group_code === "AN22" ? true : false,
                registrationFields: res["H"],
                optional_fields: res["O"],
              });
            }
          });
        } else {
          return res.json().then((res) => {
            Object.keys(res).forEach((k) => {
              Dynamic_Error(k, res[k]);
            });
          });
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  get_currency = (country) => {
    try {
      this.DataProvider.get_currency(country).then((res) => {
        if (res.ok) {
          return res.json().then((res) => {
            this.setState({ currency: res });
            if (country == "India") {
              this.formRef.current.setFieldsValue({
                currency: res[0].id,
              });
            }
          });
        } else {
          return res.json().then((res) => {
            Object.keys(res).forEach((k) => {
              openNotification(openNotificationType.error, k, res[k]);
            });
          });
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Error While Fetching Currency Dropdown data ${error}`);
      Internal_Server_Error();
    }
  };

  handleChange = (decorator, value) => {
    try {
      if (decorator === DROPDOWN_FIELDS.country) {
        //RESET CITY STATE CURRENCY
        this.formRef.current.resetFields([
          DROPDOWN_FIELDS.state,
          DROPDOWN_FIELDS.city,
          DROPDOWN_FIELDS.currency,
        ]);

        // To get Currency Values
        this.get_currency(value.name);

        //TO LOAD STATES
        this.get_dropdown_dependent_data(
          DEPENDENT_DROPDOWN_FIELDS.state.app,
          DEPENDENT_DROPDOWN_FIELDS.state.model,
          DEPENDENT_DROPDOWN_FIELDS.state.dependent,
          value.country_id,
          DEPENDENT_DROPDOWN_FIELDS.state.storein
        );
        this.get_dropdown_dependent_data(
          DEPENDENT_DROPDOWN_FIELDS.city.app,
          DEPENDENT_DROPDOWN_FIELDS.city.model,
          DEPENDENT_DROPDOWN_FIELDS.city.country_dependent,
          value.country_id,
          DEPENDENT_DROPDOWN_FIELDS.city.storein
        );

        //TO TOGGLE TAXATION SECTION AND OPTIONAL FIELDS
        if (window.location.pathname.includes("RegisterFME")) {
          this.setState({ isOptional: true });
          value.name.toString().toLowerCase() === INDIA
            ? this.setState({ pincodeLength: 6 })
            : this.setState({ pincodeLength: 10 });
        } else {
          value.name.toString().toLowerCase() === INDIA
            ? this.setState(
                {
                  taxationVisible: true,
                  pincodeLength: 6,
                  isOptional: false,
                  cin_number_status:this.state.cinRequiredIndustry,
                  isCinEnabled:this.state.cinRequiredIndustry
                },
                () => {
                if(this.state.cinRequiredIndustry)
                  {
                    this.formRef.current.setFieldsValue({
                      cin_number_status: true,
                    });
                  }
                  if (this.source === QUERY.ecommerce || this.source === QUERY.cfs) {
                    this.setState({ is_gst_required: true }, () => {
                      // GST REQUIRED IN CASE OF ECOM CUSTOMER
                      this.formRef.current.setFieldsValue({
                        gst_registration_status: true,
                      });
                    });
                  }
                }
              )
            : this.setState({
                taxationVisible: false,
                pincodeLength: 10,
                isOptional: true,
              });
        }

        //RESET TAXATION DETAILS SECTION
        Object.keys(STATUS_WISE_RESET_FIELDS).map((each_key) => {
          this.formRef.current.resetFields([
            ...STATUS_WISE_RESET_FIELDS[each_key],
            each_key,
          ]);
        });

        let { uploadedFiles } = this.state;
        Object.keys(uploadedFiles).map((decorator) => {
          if (decorator !== FILE_UPLOAD_FIELDS.balance_sheet_file) {
            delete uploadedFiles[decorator];
          }
        });
        this.setState({ uploadedFiles });
      }

      if (decorator === DROPDOWN_FIELDS.industry_type) {

        //CIN required and enabled if industry is private or public and country INDIA

        let reqIndustry =  REQ_INDUSTRIES.find(item => value.name.toString().toLowerCase().includes(item))
          if(reqIndustry !== undefined)
          {
            this.setState({
              cinRequiredIndustry : true
            })
            if(this.state.taxationVisible)
            {
              this.setState({
                cin_number_status:true,
                isCinEnabled:true
              },
              () => {
                this.formRef.current.setFieldsValue({
                  cin_number_status: true,
                });
            })
            }
          }
          else{
            if(this.state.taxationVisible &&this.state.cin_number_status)
            {
              this.setState({
                cin_number_status:false,
                isCinEnabled:false,
                cinRequiredIndustry : false
              },
              () => {
                this.formRef.current.setFieldsValue({
                  cin_number_status: false,
                });
                this.formRef.current.resetFields(['cin_number']);
                let { uploadedFiles } = this.state;
                uploadedFiles[FILE_UPLOAD_FIELDS.cin_document] = [];
                this.setState({ uploadedFiles });
            })
            }
          }

      }

      if (CONTACT_PERSON_VALIDATION_FIELDS.includes(decorator)) {
        this.contact_person_grid_data[decorator] = value["name"];
      }

      if (decorator === DROPDOWN_FIELDS.state) {
        //RESET CITY
        this.formRef.current.resetFields([DROPDOWN_FIELDS.city]);

        //TO LOAD CITIES
        this.get_dropdown_dependent_data(
          DEPENDENT_DROPDOWN_FIELDS.city.app,
          DEPENDENT_DROPDOWN_FIELDS.city.model,
          DEPENDENT_DROPDOWN_FIELDS.city.dependent,
          value.state_id,
          DEPENDENT_DROPDOWN_FIELDS.city.storein
        );

        //TO LOAD RELATED GST CODE
        this.get_dropdown_dependent_data(
          DEPENDENT_DROPDOWN_FIELDS.gstcode.app,
          DEPENDENT_DROPDOWN_FIELDS.gstcode.model,
          DEPENDENT_DROPDOWN_FIELDS.gstcode.dependent,
          value.state_id,
          DEPENDENT_DROPDOWN_FIELDS.gstcode.storein
        );
      }

      if (decorator === DROPDOWN_FIELDS.city) {
        if (value !== undefined && value[SUBMIT_VALUES.OTHER] !== undefined) {
          let { othertype } = this.state;
          this.setState(
            { othertype: { ...othertype, [decorator]: value } },
            () => {
              // TO MANAGE OTHER CITY FOR AN13
              this.setParentState({
                othertype: this.state.othertype,
              });
            }
          );
        } else {
          delete this.state.othertype[decorator];

          // TO MANAGE OTHER CITY FOR AN13
          this.setParentState({
            othertype: this.state.othertype,
          });
        }
      }

      if (decorator === DROPDOWN_FIELDS.fme) {
        if (value !== undefined) {
          this.formRef.current.setFieldsValue({
            fme_name: `${value.email}`,
          });
        }
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Exception ${decorator} with value ${value}`);
      console.error(error);
      Internal_Server_Error();
    }
  };

  handleSearch = (decorator, value) => {
    try {
      if (decorator === DROPDOWN_FIELDS.fme) {
        if (value.length >= 3) {
          this.getAllFmes(value);
        }
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Exception ${decorator} with value ${value}`);
      console.error(error);
      Internal_Server_Error();
    }
  };

  getAllFmes = (query) => {
    try {
      if(this.source && this.source == QUERY.msme){
        query += `&source=${this.source}`
      }else if(this.path.includes(SOURCE_KHOPOLI)){
        query += `&source=${SOURCE_KHOPOLI}`
      }

      this.DataProvider.get_all_fmes_api(query).then((res) => {
        if (res.ok) {
          return res.json().then((res) => this.setState({ fmeData: res }));
        } else {
          openNotification(
            openNotificationType.error,
            NOTIFICATIONS.ERROR_OCCURED,
            NOTIFICATIONS.REFRESH_PAGE
          );
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  getFileConfig = () => {
    try {
      this.DataProvider.get_file_config_api().then((res) => {
        if (res.ok) {
          return res.json().then((res) => this.setState({ fileConfigs: res }));
        } else {
          openNotification(
            openNotificationType.error,
            NOTIFICATIONS.ERROR_OCCURED,
            NOTIFICATIONS.REFRESH_PAGE
          );
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  agreeToIns = (agreeINS) => {
    this.setState({ agreeINS, agreeTC: false }, () => {
      // SET INDIA BY DEFAULT IF FOUND ECOM CUSTOMER

      if (
        this.source &&
        (this.source === QUERY.ecommerce || this.source === QUERY.msme || this.source === QUERY.cfs)
      ) {
        const row = this.state.countryData.filter(
          (each) => each.name === India
        );

        if (row.length > 0) {
          this.formRef.current.setFieldsValue({ country: row[0].country_id });
          this.handleChange(DROPDOWN_FIELDS.country, row[0]);
        }
      }

      // SET USER DATA IF RECEIVED VIA PROSPECT ID
      if (this.prospectId) {
        this.setCRMUserData();
      }
    });
  };

  toggleHTMLControls = (decorator, value) => {
    try {
      if(decorator===STATIC_STRINGS.CIN_NUMBER_STATUS)
      {
        this.setState({cin_number_status:value,isCinEnabled:value})
      }
      if (decorator === STATIC_STRINGS.director_details_status) {
        this.setState({ [decorator]: value }, () => {
          if (!value) {
            let { additional_details } = this.state;
            additional_details.director_details = [];
            this.setState({ additional_details });
          }
        });
      } else {
        let { uploadedFiles } = this.state;

        if (decorator === STATIC_STRINGS.tcs_applicable_status) {
          this.setState(
            {
              dec_letter_tooltip: DECLARATION_LETTER_TOOLTIP[value],
              is_tan_required: value === 2 ? true : false,
            },
            () =>
              this.formRef.current.setFieldsValue({
                is_tan_required: value === 2 ? true : undefined, // tan_num and tan_file required
                tan_number_status: value === 2 ? true : undefined, // set radio to yes
              })
          );
        }

        this.setState({ [decorator]: value }, () => {
          if (!value) {
            this.formRef.current.resetFields(
              STATUS_WISE_RESET_FIELDS[decorator]
            );

            STATUS_WISE_RESET_FIELDS[decorator].map((each_field) => {
              if (uploadedFiles[each_field] !== undefined) {
                uploadedFiles[each_field].map((each_file) => {
                  this.removeFile(each_file, each_field);
                });
              }
            });
          }
        });
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  downloadFile = (values) => {
    try {
      // AVOID API CALL WHEN FILE BEING DOWNLOADED FORM FILE UPLOAD ITSELF
      if (values.uid.toString().includes("rc-upload")) {
        downloadFileLocal(values);
      } else {
        this.DataProvider.download_file_api(values.uid).then((res) => {
          if (res.ok) {
            res.blob().then((blob) => {
              downloadFileFromServer(blob, values);
            });
          } else {
            if (res.status == 400) {
              res.json().then((res) => {
                openNotification(
                  openNotificationType.error,
                  notificationTitle.api,
                  res.message
                );
              });
            } else {
              var file = values;
              downloadFileLocal(file);
            }
          }
        });
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  onClear = (decorator) => {
    try {
      if (decorator === DROPDOWN_FIELDS.fme) {
        this.formRef.current.setFieldsValue({
          fme_name: "",
        });
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Exception ${decorator}`);
      console.error(error);
    }
  };

  validateAadharNumber = (decorator, value) => {
    try {
      //Aadhar Mandatory if PAN number contains P as 4 letter
      if (value !== undefined && value !== null) {
        if (value.length >= 4) {
          if (value.charAt(3) == "P" || value.charAt(3) == "p") {
            this.setState({ aadharRequired: true });
          } else {
            this.setState({ aadharRequired: false });
          }
        } else {
          this.setState({ aadharRequired: false });
        }
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Exception ${decorator} with value ${value}`);
      console.error(error);
    }
  };

  validateGSTNumber = (decorator, value) => {
    try {
      //GST NUMBER SHOULD CONTAIN PAN NUMBER
      if (value !== undefined && value !== null) {
        const pan_num = this.formRef.current.getFieldValue(
          SCROLL_TO_FIELD_FOR_FILE.pan_document[0]
        );

        let errors = "";
        // PAN VALIDATION
        if (!value.toString().includes(pan_num.toString())) {
          this.formRef.current.scrollToField(
            SCROLL_TO_FIELD_FOR_FILE.gst_document[0]
          );
          errors = NOTIFICATIONS.VALIDATE_GST;

          // FIRST 2 DIGIT MUST BE GST CODE BASED ON STATE
        } else if (
          !value.slice(0, 2).toString().includes(this.state.gstCodeData[0].name)
        ) {
          errors = NOTIFICATIONS.VALIDATE_GST;
        } else {
          errors = "";
        }

        this.formRef.current.setFields([
          {
            name: SCROLL_TO_FIELD_FOR_FILE.gst_document[0],
            errors,
          },
        ]);
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Exception ${decorator} with value ${value}`);
      console.error(error);
    }
  };

  validateMobTeleEmail = (values, regex, msg) => {
    try {
      let isValidMobTeleEmail = true;
      values.map((each, index) => {
        if (!each.match(regex)) {
          openNotification(
            openNotificationType.error,
            notificationTitle.form,
            each + msg
          );

          isValidMobTeleEmail = false;
        }
      });

      if (!isValidMobTeleEmail) {
        this.formRef.current.scrollToField(
          SCROLL_TO_FIELD_FOR_MULTIV.contact_person_designation
        );
      }

      return isValidMobTeleEmail;
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
    }
  };

  handleDirectorDetails = async (id, action) => {
    try {
      let { additional_details } = this.state;
      let isValid = await this.formRef.current
        .validateFields(DIRECTOR_FIELDS)
        .catch(this.onFinishFailed);

      if (isValid) {
        switch (action) {
          case Actions.update:
            // FILTER AND SET VALUES
            const record =
              this.state.additional_details.director_details.filter(
                (row) => row.id === id
              )[0];

            Object.keys(record).map((each_field) => {
              this.formRef.current.setFieldsValue({
                [each_field]: record[each_field],
              });
            });

            // STORE ID & REMOVE OLD RECORD
            this.updatedId = id;
            additional_details.director_details =
              additional_details.director_details.filter(
                (row) => row.id !== id
              );
            break;

          case Actions.delete:
            additional_details.director_details =
              additional_details.director_details.filter(
                (row) => row.id !== id
              );
            break;

          default:
            const values = this.formRef.current.getFieldsValue(director_fields);

            // TRIM TO REMOVE SPACES
            Object.keys(values).forEach(
              (each) => (values[each] = values[each].toString().trim())
            );

            const isValid = director_details_validator(values, this.formRef);

            // UPDATE id TO MAINTAIN IF REC IS UPDATED or NEED TO INSERT IN BACKEND
            if (this.updatedId !== null) {
              values.id = this.updatedId;
              this.updatedId = null;
            } else {
              // GENERATE RANDOM ID SO CONSIDERED AS NEW RECORD
              values.id = randomString(7);
            }

            // APPEND WITH PREVIOUS RECORDS
            if (isValid) {
              let { additional_details } = this.state;
              additional_details.director_details = [
                ...additional_details.director_details,
                values,
              ];

              // CLEAR ONCE SUBMITTED
              Object.keys(values).map((each_field) => {
                this.formRef.current.setFieldsValue({
                  [each_field]: null,
                });
              });
            }
            break;
        }
        this.setState({ additional_details });
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  handleContactPersonDetails = async (id, action, event = null) => {
    try {
      let { additional_details } = this.state;
      let isValid = await this.formRef.current
        .validateFields(CONTACT_PERSON_FIELDS)
        .catch(this.onFinishFailed);

      if (isValid) {
        switch (action) {
          case Actions.update:
            // FILTER AND SET VALUES
            this.record =
              this.state.additional_details.contact_person_details.filter(
                (row) => row.id === id
              )[0];

            Object.keys(this.record).map((each_field) => {
              this.formRef.current.setFieldsValue({
                [each_field]: this.record[each_field],
              });
            });

            // SET MULTIVALUE FIELDS INTO STATE AS WELL AS INTO ANTD CONTROL
            const { multivalue_fields } = this.state;
            Object.keys(CONTACT_PERSON_MULTIVALUE_FIELDS).forEach(
              (each_field) => {
                multivalue_fields[each_field] = this.stringToArray(
                  this.record[each_field]
                );

                this.formRef.current.setFieldsValue({
                  [each_field]: multivalue_fields[each_field],
                });
              }
            );

            // RETAIN multivalue_fields_original VALUES IF RECORD IS ALREDY EDITED AND IS IN RE-EDITING
            let multivalue_fields_original = JSON.stringify(multivalue_fields);
            if ("old_multivalue_fields" in this.record) {
              multivalue_fields_original = JSON.stringify(
                this.record.old_multivalue_fields
              );
            }

            this.setState({ multivalue_fields, multivalue_fields_original });

            // STORE ID & REMOVE OLD RECORD
            this.updatedId = id;
            additional_details.contact_person_details =
              additional_details.contact_person_details.filter(
                (row) => row.id !== id
              );
            break;
          case Actions.delete:
            additional_details.contact_person_details =
              additional_details.contact_person_details.filter(
                (row) => row.id !== id
              );
            break;
          case Actions.radio:
            // TO RESTRICT USER TO HAVING ATLEAST ONE PRIMARY CONTACT PERSON DETAIL
            if (
              event.target.value !== STATUS_RADIO.primary &&
              additional_details.contact_person_details.findIndex(
                (each) =>
                  each.id !== id &&
                  each.contact_person_status === STATUS_RADIO.primary
              ) === -1
            ) {
              openNotification(
                openNotificationType.warning,
                notificationTitle.form,
                NOTIFICATIONS.ATLEAST_ONE_PRIMARY
              );
            } else {
              additional_details.contact_person_details.forEach((value) => {
                if (value.id === id) {
                  value.contact_person_status = event.target.value;
                } else {
                  // SET EXISTING PRIMARY STATUS TO SECONDARY BECAUSE ONLY ONE CONTACT CAN BE PRIMARY
                  if (
                    event.target.value === STATUS_RADIO.primary &&
                    value.contact_person_status === STATUS_RADIO.primary
                  ) {
                    value.contact_person_status = STATUS_RADIO.secondary;
                  }
                }
              });
            }
            break;
          default:
            const values = this.formRef.current.getFieldsValue(
              CONTACT_PERSON_FIELDS
            );

            // TO HANDLE MULTI VALUE FIELDS
            Object.keys(CONTACT_PERSON_MULTIVALUE_FIELDS).forEach(
              (each_field) => {
                values[each_field] = this.arrayToString(values[each_field]);
              }
            );

            // TRIM TO REMOVE SPACES
            Object.keys(values).forEach((each) => {
              if (!AVOID_IN_TRIM.includes(each) && values[each]) {
                values[each] = values[each].toString().trim();
              }
            });

            const isValid = contact_person_validator(values, this.formRef);

            // VALIDATE MULTI VALUE FIELDS
            if (
              !values.contact_person_mobile_number &&
              !values.contact_person_telephone_number
            ) {
              openNotification(
                openNotificationType.error,
                notificationTitle.form,
                NOTIFICATIONS.MOBILE
              );
              return;
            } else if (!values.contact_person_email) {
              openNotification(
                openNotificationType.error,
                notificationTitle.form,
                NOTIFICATIONS.EMAIL_INVALID
              );
              return;
            }

            if (isValid) {
              // RETAIN VALUES IN CASE RECORD IS EDITED BUT DROPDOWN VALUES ARE UNCHANGED
              RETAIN_VALUES.forEach((field) => {
                values[field.alias] =
                  this.contact_person_grid_data[field.decorator] !== undefined
                    ? this.contact_person_grid_data[field.decorator]
                    : this.record[field.alias];
              });

              // UPDATE id TO MAINTAIN IF REC IS UPDATED or NEED TO INSERT IN BACKEND
              if (this.updatedId !== null) {
                values.id = this.updatedId;
                values.contact_person_status =
                  this.record.contact_person_status;
                this.updatedId = null;
                this.record = null;
                this.contact_person_grid_data = {};
              } else {
                // GENERATE RANDOM ID SO CONSIDERED AS NEW RECORD
                values.id = randomString(7);

                // DEFAULT PRIMARY ONLY IF FIRST RECORD
                if (
                  this.state.additional_details.contact_person_details
                    .length === 0
                ) {
                  values.contact_person_status = STATUS_RADIO.primary;
                } else {
                  values.contact_person_status = STATUS_RADIO.secondary;
                }
              }

              // TO MAIN OLD AND NEW UPDATED VALUES FOR MULTIVALUE FIELDS
              values.old_multivalue_fields =
                typeof this.state.multivalue_fields_original == "string"
                  ? JSON.parse(this.state.multivalue_fields_original)
                  : this.state.multivalue_fields_original;
              values.new_multivalue_fields = {
                ...this.state.multivalue_fields,
              };

              // APPEND WITH PREVIOUS RECORDS
              let { additional_details } = this.state;
              additional_details.contact_person_details = [
                ...additional_details.contact_person_details,
                values,
              ];

              // CLEAR ONCE SUBMITTED
              Object.keys(values).map((each_field) => {
                this.formRef.current.setFieldsValue({
                  [each_field]: null,
                });
              });

              // UPDATE STATE TO CLEAR MULTIVALUE FIELDS
              let { multivalue_fields, multivalue_fields_original } =
                this.state;
              multivalue_fields_original =
                typeof this.state.multivalue_fields_original == "string"
                  ? JSON.parse(multivalue_fields_original)
                  : multivalue_fields_original;

              Object.keys(CONTACT_PERSON_MULTIVALUE_FIELDS).forEach(
                (each_field) => {
                  multivalue_fields[each_field] = [{ id: 0, value: "" }];
                  multivalue_fields_original[each_field] = [];
                }
              );
              this.setState({ multivalue_fields, multivalue_fields_original });
            }
            break;
        }
        this.setState({ additional_details, updateGrid: false }, () => {
          this.setState({ updateGrid: true }, () => {
            this.setParentState({ additional_details: additional_details });
          });
        });
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  // Method is used to pass an array and it will return comma separated string
  arrayToString = (array) => {
    if (!array) return "";

    let value = "";
    array.forEach((each) => {
      if (each.value) {
        value += each.value + ",";
      }
    });
    return value.slice(0, -1);
  };

  // Method is used to pass a string and it will return array to use in multivalue fields
  stringToArray = (string) => {
    const array = [];
    string = string ? string : "";
    string.split(",").forEach((value, id) => {
      array.push({ id, value });
    });
    return array;
  };

  // TO HANDLE MULTIVALUE FIELDS WHICH MIGHT REQUIRE RESET / CLEAR OR TO MANAGE STATE ON PARENT
  handleMultivalueFields = (decorator, value) => {
    let { multivalue_fields } = this.state;
    multivalue_fields[decorator] = value;

    this.setState({ multivalue_fields });
  };

  // Used to send child state to parent state if needed
  setParentState = (dict = {}) => {
    try {
      if (this.props.getChildState !== undefined) {
        // dict OF {decotaror:value}
        this.props.getChildState(dict);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Get countries to set by default india for ecom customers
  getCountries = () => {
    try {
      this.DataProvider.get_dropdown_data_api(
        DROPDOWN_FIELDS.app,
        DROPDOWN_FIELDS.country
      ).then((res) => {
        if (res.ok) {
          return res.json().then((res) => {
            this.setState({ countryData: res }, () => {
              if (
                this.source &&
                (this.source === QUERY.ecommerce || this.source === QUERY.msme || this.source === QUERY.cfs)
              ) {
                const row = this.state.countryData.filter(
                  (each) => each.name === India
                );

                if (row.length > 0) {
                  this.formRef.current.setFieldsValue({
                    country: row[0].country_id,
                  });
                  this.handleChange(DROPDOWN_FIELDS.country, row[0]);
                }
              }
            });
          });
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  // To get user data via salesforce api
  getDataByProspectId = (id) => {
    try {
      this.setState({
        isLoading: true,
        message: NOTIFICATIONS.LOADING_CRM_DATA,
      });
      this.DataProvider.get_data_by_prospectid_api(id)
        .then((res) => {
          if (res.ok) {
            return res
              .json()
              .then((res) => this.setState({ crmUserData: res }));
          } else {
          }
        })
        .catch((error) => {
          ErrorLogger(error.toString());
        })
        .finally(() => {
          this.setState({
            isLoading: false,
            message: NOTIFICATIONS.PLEASE_WAIT,
          });
        });
    } catch (error) {
      ErrorLogger(error.toString());
      Internal_Server_Error();
    }
  };

  setCRMUserData = () => {
    try {
      const { crmUserData, additional_details } = this.state;

      // HANDLE ACTIVITY WHICH IS DONE BASED ON DROPDOWN VALUES
      if (crmUserData.country) {
        this.handleChange(DROPDOWN_FIELDS.country, {
          country_id: crmUserData.country,
          name: crmUserData.country_name,
        });
      }

      if (crmUserData.state) {
        this.handleChange(DROPDOWN_FIELDS.state, {
          state_id: crmUserData.state,
          name: crmUserData.state_name,
        });
      }

      // HANDLE HTML RADIO FIELDS
      if (crmUserData.gst_registration_status) {
        this.toggleHTMLControls(FIELD_ALIAS.gst.decorator, true);
      }

      // LOAD CONTACT PERSON DATA AND DISABLED AUTO POPULATED FIELDS
      additional_details.contact_person_details =
        crmUserData.contact_person_details;

      this.setState({ additional_details });

      Object.keys(crmUserData).map((decorator) => {
        this.formRef.current.setFieldsValue({
          [decorator]: crmUserData[decorator],
        });
      });
    } catch (error) {
      ErrorLogger(error.toString());
      Internal_Server_Error();
    }
  };

  triggerRegistrationOTP = (customerData) => {
    const customerName = customerData.customer_name.replaceAll(' ', '_');
    const custPrimaryEmail = customerData.contact_person_details.find((item) => item.contact_person_status.includes('Primary')).contact_person_email;
    const contactPersonEmail = customerData.contact_person_details.map((item) => item.contact_person_email);

    const payload = {
      otp_unq_key: `${customerName}-${custPrimaryEmail}`,
      contact_person_email: contactPersonEmail,
      customer_name: customerData.customer_name
    }
    this.setState({registrationOtpPayload: payload});

    try {
      this.setState({ isLoading: true });
      this.DataProvider.generate_registration_otp(payload)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              this.setState({ isLoading: false });
              openNotification(
                openNotificationType.success,
                res.Success
              );
              localStorage.setItem("registration-otp-duration", res.duration);
              this.setState({ isLoading: false, showOTPModal: true });
            });
          }
          else {
            this.setState({ isLoading: false, showOTPModal: false });
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() =>
          this.setState({
            isLoading: false
          })
        );
    }
    catch (error) {
      this.setState({ isLoading: false, showOTPModal: false });
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  }

  validateRegistrationOTP = (registrationOTP) => {
    const {customer_name, otp_unq_key} = this.state.registrationOtpPayload;
    const payload = {
      registration_otp: registrationOTP,
      customer_name: customer_name,
      customer_unq_key: otp_unq_key
    }

    try {
      this.setState({ isLoading: true });
      this.DataProvider.validate_registration_otp(payload)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              openNotification(
                openNotificationType.success,
                res.Success
              );
              this.registerCustomer(this.state.pendingRegistrationData, res.unique_cust_id);
            });
          }
          else {
            this.setState({ isLoading: false });
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
    }
    catch (error) {
      this.setState({ isLoading: false, showOTPModal: false });
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }

  }

  handleOTPRegistration = (values) => {
    if(!Boolean(values.registration_otp)){
      openNotification(
          openNotificationType.error,
          notificationTitle.form,
          `Enter Registration OTP.`
        );
        return;
    }
    this.validateRegistrationOTP(values.registration_otp)
  }

  onChangeText = (decorator, value) => { };

  render() {
    const {
      isLoading,
      agreeINS,
      agreeTC,
      uploadedFiles,
      taxationVisible,
      fmeData,
      statesData,
      pincodeLength,
      fileConfigs,
      citiesData,
      otherCity,
      isInEdit,
      gst_registration_status,
      tcs_applicable_status,
      cin_number_status,
      tan_number_status,
      additional_details,
      editDataAvailable,
      versionList,
      message,
      tcsStatus,
      showSave,
      isStaff,
      isOptional,
      currency,
      director_details_status,
      registrationFields,
      isAN13Update,
      isAN22,
      isRequired,
      aadharRequired,
      optional_fields,
      disable_fme,
      req_op_fields,
      customer_sap_code,
      dec_letter_tooltip,
      is_tan_required,
      is_gst_required,
      countryData,
      updateGrid,
      is_verified_in_mdm,
      is_udyam_required,
      is_udyam_visible,
      multivalue_fields,
      isCinEnabled,
      cinRequiredIndustry,
      is_reverted_in_mdm,
      showOTPModal,
      registrationOtpPayload
    } = this.state;

    const { is_AN13 } = this.props;

    return (
      <>
        {isLoading && <CustomLoader message={message} />}

        {!is_AN13 && (
          <Form
            ref={this.formRef}
            className={`ant-form ant-form-vertical ${
              !isInEdit && "p-5 extra-padding"
            }`}
            onFinish={isStaff ? this.receiveMails : this.onFinish}
            onFinishFailed={this.onFinishFailed}
            autoComplete="off"
          >
            <CustomHeader
              isInEdit={isInEdit}
              isStaff={isStaff}
              goToLogin={this.goToLogin}
              agreeToIns={this.agreeToIns}
              onBackPressed={this.onBackPressed}
              formRef={this.formRef}
              disabled={this.isDisabled}
              customer_sap_code={customer_sap_code}
              showSave={isAN22 ? false : !is_verified_in_mdm ? true : showSave}
              showLogin={this.source || this.reference ? false : true}
            />

            <div hidden={!agreeINS}>
              <GeneralDetails
                {...this.props}
                formRef={this.formRef}
                handleChange={this.handleChange}
                countryData={countryData}
                statesData={statesData}
                citiesData={[...citiesData, ...otherCity]}
                industriesData={this.state.industriesData}
                pincodeLength={pincodeLength}
                isDisabled={this.isDisabled}
                isOptional={isOptional}
                isInEdit={isInEdit}
                isStaff={isStaff}
                isRequired={isRequired}
                optionalFields={
                  optional_fields !== undefined ? optional_fields : {}
                }
                registrationFields={
                  registrationFields !== undefined ? registrationFields : {}
                }
                req_op_fields={req_op_fields}
                isAN13Update={isAN13Update}
                is_gst_required={is_gst_required}
                isAN22OrAN13={is_AN13 || isAN13Update || isAN22 ? true : false}
              />

              {taxationVisible && !isAN13Update && !isAN22 && (
                <TaxationDetails
                  formRef={this.formRef}
                  addFile={this.addFile}
                  removeFile={this.removeFile}
                  uploadedFiles={uploadedFiles}
                  fileConfigs={fileConfigs}
                  gst_registration_status={gst_registration_status}
                  tcs_applicable_status={tcs_applicable_status}
                  is_tan_required={is_tan_required}
                  cin_number_status={cin_number_status}
                  isCinEnabled={isCinEnabled}
                  cinRequiredIndustry={cinRequiredIndustry}
                  tan_number_status={tan_number_status}
                  toggleHTMLControls={this.toggleHTMLControls}
                  previewFile={this.downloadFile}
                  isDisabled={this.isDisabled}
                  validateGSTNumber={this.validateGSTNumber}
                  validateAadharNumber={this.validateAadharNumber}
                  aadharRequired={aadharRequired}
                  tcsStatus={tcsStatus}
                  req_op_fields={req_op_fields}
                  dec_letter_tooltip={dec_letter_tooltip}
                  is_gst_required={is_gst_required}
                  is_udyam_visible={
                    is_udyam_visible
                      ? true
                      : this.source && this.source === QUERY.msme
                      ? true
                      : false
                  }
                  is_udyam_required={is_udyam_required}
                  onChangeText={this.onChangeText}
                  is_reverted_in_mdm={is_reverted_in_mdm}
                />
              )}

              {taxationVisible && isAN22 && (
                <AN22TaxationDetails
                  formRef={this.formRef}
                  gst_registration_status={gst_registration_status}
                  isDisabled={this.isDisabled}
                  validateGSTNumber={this.validateGSTNumber}
                  validateAadharNumber={this.validateAadharNumber}
                  aadharRequired={aadharRequired}
                  req_op_fields={req_op_fields}
                />
              )}

              {!isAN13Update && (
                <PaymentDetails
                  formRef={this.formRef}
                  addFile={this.addFile}
                  removeFile={this.removeFile}
                  uploadedFiles={uploadedFiles}
                  fileConfigs={fileConfigs}
                  previewFile={this.downloadFile}
                  isDisabled={this.isDisabled}
                  currency={currency}
                  isAN22={isAN22}
                />
              )}

              {!isAN22 && (
                <FMEDetails
                  formRef={this.formRef}
                  handleChange={this.handleChange}
                  handleSearch={this.handleSearch}
                  onClear={this.onClear}
                  fmeData={fmeData}
                  isDisabled={
                    disable_fme
                      ? disable_fme
                      : this.source && (this.source === QUERY.ecommerce || this.source === QUERY.cfs)
                  }
                  source={this.source}
                />
              )}

              <CompanyDetails
                formRef={this.formRef}
                isDisabled={this.isDisabled}
                editDataAvailable={editDataAvailable}
                editFormData={additional_details}
              />

              {this.path.includes(SOURCE_KHOPOLI) && (
                <BankDetails
                  formRef={this.formRef}
                  isDisabled={this.isDisabled}
                />
              )}

              <ContactPersonDetails
                formRef={this.formRef}
                isDisabled={this.isDisabled}
                isRequired={isRequired}
                additional_details={additional_details}
                handleChange={this.handleChange}
                isIndia={pincodeLength === 6 ? true : false}
                handleContactPersonDetails={this.handleContactPersonDetails}
                updateGrid={updateGrid}
                hideActions={isStaff ? false : isInEdit ? true : false}
                source={this.source}
                handleMultivalueFields={this.handleMultivalueFields}
                multivalue_fields={multivalue_fields}
              />

              <AdditionalDetails
                {...this.props}
                formRef={this.formRef}
                editDataAvailable={editDataAvailable}
                editFormData={additional_details}
                isDisabled={this.isDisabled}
                isIndia={pincodeLength === 6 ? true : false}
                toggleHTMLControls={this.toggleHTMLControls}
                registrationFields={
                  registrationFields !== undefined ? registrationFields : {}
                }
                isRequired={isRequired}
                optionalFields={
                  optional_fields !== undefined ? optional_fields : {}
                }
                isAN13Update={isAN13Update}
                isAN22={isAN22}
                disabledTeleMobEmail={(isInEdit && !isStaff) ? true : false}
                req_op_fields={req_op_fields}
              />

              {director_details_status && (
                <DirectorDetails
                  formRef={this.formRef}
                  additional_details={additional_details}
                  isDisabled={this.isDisabled}
                  handleDirectorDetails={this.handleDirectorDetails}
                  isIndia={pincodeLength === 6 ? true : false}
                />
              )}

              <CustomFooter
                agreeTC={agreeTC}
                isInEdit={isInEdit}
                versionList={versionList}
                handleTC={(agreeTC) => this.setState({ agreeTC })}
                isStaff={isStaff}
              />
            </div>
          </Form>
        )}

        {is_AN13 && (
          <div hidden={!agreeINS}>
            <GeneralDetails
              {...this.props}
              formRef={this.formRef}
              handleChange={this.handleChange}
              countryData={countryData}
              statesData={statesData}
              citiesData={[...citiesData, ...otherCity]}
              industriesData={this.state.industriesData}
              pincodeLength={pincodeLength}
              isDisabled={this.isDisabled}
              optionalFields={
                optional_fields !== undefined ? optional_fields : {}
              }
              isOptional={isOptional}
              req_op_fields={req_op_fields}
              is_AN13={is_AN13}
              is_gst_required={is_gst_required}
              isAN22OrAN13={is_AN13 || isAN13Update || isAN22 ? true : false}
            />

            <FMEDetails
              formRef={this.formRef}
              handleChange={this.handleChange}
              handleSearch={this.handleSearch}
              onClear={this.onClear}
              fmeData={fmeData}
              isDisabled={this.isDisabled}
              is_AN13={is_AN13}
              source={this.source}
            />

            <CompanyDetails
              formRef={this.formRef}
              isDisabled={this.isDisabled}
              editDataAvailable={editDataAvailable}
              editFormData={additional_details}
            />

            <ContactPersonDetails
              formRef={this.formRef}
              isDisabled={this.isDisabled}
              isRequired={isRequired}
              isIndia={pincodeLength === 6 ? true : false}
              additional_details={additional_details}
              handleChange={this.handleChange}
              handleContactPersonDetails={this.handleContactPersonDetails}
              updateGrid={updateGrid}
              hideActions={false}
              handleMultivalueFields={this.handleMultivalueFields}
              multivalue_fields={multivalue_fields}
            />

            <AdditionalDetails
              {...this.props}
              formRef={this.formRef}
              isDisabled={this.isDisabled}
              isIndia={pincodeLength === 6 ? true : false}
              toggleHTMLControls={this.toggleHTMLControls}
              optionalFields={
                optional_fields !== undefined ? optional_fields : {}
              }
              is_AN13={is_AN13}
              disabledTeleMobEmail={false}
              req_op_fields={req_op_fields}
            />
          </div>
        )}

        <Modal
          open={showOTPModal}
          onCancel={() => this.setState({ showOTPModal: false })}
          footer={null}
          wrapClassName={`registration-otp-container`}
          maskClosable={true}
          closable={false}
        >
          <Form
            onFinish={this.handleOTPRegistration}
            layout="vertical"
            ref={this.otpFormRef}
            className="container_bg text-center"
            autoComplete="off"
          >
            <Card
              title={`OTP for Customer Registration`}
              className="main_card p-1"
            >
              <Card.Grid style={{width:"100%"}} hoverable={false}>
                <div className="col-lg-12 col-md-12 text-right">
                    <RegistrationTimer
                      formRef={this.otpFormRef}
                      currentStep={this.currentStep}
                      registrationOtpPayload={registrationOtpPayload}
                    />
                </div>

                <div className="col-lg-12 col-md-12 text-center">
                  <Button htmlType="submit" type="primary">
                    Submit
                  </Button>
                </div>
              </Card.Grid>
            </Card>
          </Form>
        </Modal>

        <BackTop />
      </>
    );
  }
}

export default RegistrationFormView;
